import React, { Component } from 'react';
 
import { Divider } from '@jd/find-react';
  
import KeeVue from '../base/KeeVue.js'
export default class FsDivider extends KeeVue {
  constructor(props){
    super(props);
    this.state = { };
  };

 componentDidMount() {
  
 	this.registComponent(); 
 
 }
 
 
 componentWillReceiveProps(nextProps){
	 
	 this.refresh();
	}

// className	分割线样式类	string	-	
// dashed	是否虚线	boolean	false	
// orientation	分割线标题的位置	left | right | center	center	
// style	分割线样式对象	CSSProperties	-	
// type	水平还是垂直类型	horizontal | vertical	horizontal	
// plain

  render() {
	  
    let style = JSON.parse(JSON.stringify(this.props.component.style));
   
    return (
     <div  > 
        <Divider 
			className={this.props.component.cp.className}
			dashed={this.props.component.cp.dashed}
			orientation={this.props.component.cp.orientation}
			 
			type={this.props.component.cp.type} 
        >{this.props.component.cp.title}</Divider>
     </div>
    )
  }
}